const routes = require("../api/routes.json");

const API_DOMAIN = '';
const api = routes; // JSON.parse(routes);

module.exports = {
    API_DOMAIN,
    api
};
